export default "__VITE_ASSET__BM25lFWf__"